import { Controller } from "@hotwired/stimulus"
import { EXAMPLE_DATA } from "./example_data"

// Example mode controller - provides demo data for testing the wizard
export default class extends Controller {
  static values = {
    isActive: Boolean
  }
  
  static targets = [
    "exampleModeBanner", "exampleFloatingBanner"
  ]
  
  static outlets = ["onboarding-wizard", "onboarding--icp"]

  connect() {
    this.isActiveValue = false
  }

  load(event) {
    if (event) event.preventDefault()
    
    console.log('[exampleMode] Loading example data')
    
    this.isActiveValue = true
    const { company, personas } = EXAMPLE_DATA

    // Populate form fields via wizard outlet
    if (this.hasOnboardingWizardOutlet) {
      this.onboardingWizardOutlet.populateFormFields(company)
    }

    // Store example data for controllers to use
    this._examplePersonas = personas

    // Show banners
    this.showBanners()

    // Navigate to the personas step
    if (this.hasOnboardingWizardOutlet) {
      this.onboardingWizardOutlet.goToStep(3)
    }
  }

  startFresh(event) {
    if (event) event.preventDefault()
    
    console.log('[exampleMode] Starting fresh')
    
    this.isActiveValue = false
    this._examplePersonas = null

    // Clear form fields
    if (this.hasOnboardingWizardOutlet) {
      this.onboardingWizardOutlet.clearFormFields()
    }
    
    // Hide banners
    this.hideBanners()
    
    // Go back to step 0
    if (this.hasOnboardingWizardOutlet) {
      this.onboardingWizardOutlet.goToStep(0)
    }
  }

  showBanners() {
    this.exampleModeBannerTargets.forEach(target => {
      target.classList.remove('hidden')
    })
    this.exampleFloatingBannerTargets.forEach(target => {
      target.classList.remove('hidden')
    })
  }

  hideBanners() {
    this.exampleModeBannerTargets.forEach(target => {
      target.classList.add('hidden')
    })
    this.exampleFloatingBannerTargets.forEach(target => {
      target.classList.add('hidden')
    })
  }

  // Provide example personas to ICP controller
  getExamplePersonas() {
    return this._examplePersonas || []
  }
}
